/*
  Dtcs state
*/
export default {
  loading: false,
  eventList: [],
  eventDictList: [],
  telemetryEventsList: [],
  timeList: {
    today: [],
    yesterday: [],
    thisWeek: [],
    lastWeek: []
  }
}
